/**
 * @desc 供应商文件下载（合同，附件）
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierInfo.downloadSupplierFiles.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/download/supplierFiles`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
